/**
 * Underscore 扩展方法
 * 用于兼容 lodash 部分方法
 */

import _ from "underscore";

_.mixin({

  /**
   * 将数组分割成指定大小的块
   * lodash: _.chunk([1,2,3,4,5], 2) => [[1,2], [3,4], [5]]
   */
  chunk(array, size = 1) {
    if (!Array.isArray(array) || size <= 0) return [];

    const result = [];

    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }

    return result;
  },

  /**
   * 从数组中移除满足条件的元素（原地修改）
   * lodash: _.remove(array, predicate)
   * 返回被移除的元素
   */
  remove(array, predicate) {
    if (!Array.isArray(array)) return [];

    const predicateFn = _.isFunction(predicate)
      ? predicate
      : _.matches(predicate);

    const removed = [];

    for (let i = array.length - 1; i >= 0; i--) {
      if (predicateFn(array[i], i, array)) {
        removed.unshift(array.splice(i, 1)[0]);
      }
    }

    return removed;
  },

  /**
   * 数组连接成字符串
   * lodash: _.join(array, separator)
   */
  join(array, separator = ",") {
    return Array.isArray(array) ? array.join(separator) : "";
  }

});

export default _;
